/* leaving Search commented out until we build in Search feature */
export const homeLink = {
  label: 'Blog',
  url: '/',
  icon:
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M3 9v6h10V9M1 7l7-6 7 6M8 15v-3"/></g></svg>',
};

export const topicsLink = {
  label: 'Topics',
  url: '/categories/',
  icon:
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M6 2h8M6 6h5M6 10h8M6 14h5M2 2h1M2 6h1M2 10h1M2 14h1"/></g></svg>',
};
